// removed by extract-text-webpack-plugin
module.exports = {"detail_card":"components-zxjfgl-jffagl-detail-detail_card-I_YU7","editIcon":"components-zxjfgl-jffagl-detail-editIcon-FzF75","updateIcon":"components-zxjfgl-jffagl-detail-updateIcon-2SvJG","deleteIcon":"components-zxjfgl-jffagl-detail-deleteIcon-1L4VT","main_right_content":"components-zxjfgl-jffagl-detail-main_right_content-3sRSa","table":"components-zxjfgl-jffagl-detail-table-1qiSu"};


//////////////////
// WEBPACK FOOTER
// ./components/zxjfgl/jffagl/detail.css
// module id = 830
// module chunks = 0